export enum PaginateEnum {
  NEXT_DAY = "nextDay",
  PREV_DAY = "prevtDay",
  IS_NOW = "now",
  REFRESH = "refresh"
}

export interface CalendarProperty {
  maxDate: string,
  minDate: string,
  date: string,
  paginator: boolean
}

export interface MessageProperty {
  icon: string;
  title: string;
  body: any;
  show: boolean
}

export interface OnEventProperty {
  isNow(): boolean,
  isValidated() : boolean,
  calendar: {
    pickCalendar(calendar: CalendarProperty),
    paginate(step: PaginateEnum),
  },
  block: {
    click(),
    hover(block: any): {template: string},
    dragend?(),
    drag?(),
    init?()
    patch?(),
    MOTIFS: Array<any> // remove
  }
}

export interface ChartProperty {
  selector: string;
  initialView: 'ONLY_DATA' | 'FULL';
  timeZone: number;
  data: any;
  calendar: CalendarProperty,
  message: MessageProperty;
  extras?: { BLOCK_DATE_FORMAT?: string; };
  translations: { lang: string; translate: any },
  on: OnEventProperty
  [key: string]: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/chartBlocks/ChartVO.ts